import { create } from 'zustand';

/**
 * Mitteilungen der Prüfungsleitung (Relay `MESSAGE`), bis der Prüfer sie gelesen hat.
 *
 * Relay stellt eine Mitteilung bei jedem Abgleich erneut zu, bis sie quittiert ist — und
 * quittiert wird erst, wenn der Prüfer „Gelesen" getippt hat (Relay-Nachtrag 2026-10-07).
 * Deshalb kommt dieselbe Kennung oft mehrmals an; `melde` nimmt sie nur einmal.
 *
 * ⚠️ **Die Bestätigung liegt nur im Speicher.** Der Abgleich liest und schreibt seine Liste
 * erledigter Befehle (`relay.erledigt`) selbst. Schriebe der Dialog dieselbe Liste, könnten
 * sich beide gegenseitig überschreiben. So trägt der Abgleich die bestätigte Kennung bei
 * seinem nächsten Lauf ein und quittiert. Startet die App dazwischen neu, zeigt Stage die
 * Mitteilung noch einmal — doppelt gezeigt ist besser als verloren (`server/nachrichten.ts`).
 */

export interface Mitteilung {
  id: string;
  text: string;
}

interface AufsichtState {
  /** Was der Prüfer noch nicht bestätigt hat, älteste zuerst. */
  offen: Mitteilung[];
  /** Bestätigt, aber vielleicht noch nicht quittiert. */
  bestaetigt: string[];
  /** `true`, wenn die Mitteilung neu ist — weder offen noch schon bestätigt. */
  melde: (id: string, text: string) => boolean;
  bestaetige: (id: string) => void;
}

export const useAufsichtStore = create<AufsichtState>()((set, get) => ({
  offen: [],
  bestaetigt: [],
  melde: (id, text) => {
    const s = get();
    if (s.bestaetigt.includes(id) || s.offen.some((m) => m.id === id)) return false;
    set({ offen: [...s.offen, { id, text }] });
    return true;
  },
  bestaetige: (id) =>
    set((s) => ({
      offen: s.offen.filter((m) => m.id !== id),
      bestaetigt: s.bestaetigt.includes(id) ? s.bestaetigt : [...s.bestaetigt, id],
    })),
}));
